/** Cada id ocupa 48 caracteres y la línea de petición de uvicorn/h11 topa en 8 KB (~170 ids);
 * 120 deja el peor caso en ~5,8 KB. */
export const MAX_PAQUETES_EN_URL = 120

export type DestinoSeleccion = {tipo: 'cola'; query: string} | {tipo: 'demasiadas'; sobran: number}

/** Con todas marcadas navega sin `paquete_id` (el servidor lo lee como el lote entero); si no
 * caben en la URL no recorta en silencio: devuelve cuántas sobran. */
export function destinoDeSeleccion(seleccionados: string[], totalDelLote: number): DestinoSeleccion {
  const params = new URLSearchParams()
  const todas = totalDelLote > 0 && seleccionados.length >= totalDelLote
  if (!todas) {
    if (seleccionados.length > MAX_PAQUETES_EN_URL) {
      return {tipo: 'demasiadas', sobran: seleccionados.length - MAX_PAQUETES_EN_URL}
    }
    for (const id of seleccionados) params.append('paquete_id', id)
  }
  // Inerte hasta que la cola tenga su panel de filtros: hoy nadie lo lee.
  params.set('filtros', '1')
  return {tipo: 'cola', query: params.toString()}
}
